import routeInfoHasRoute from 'rise-ui/utils/route-info-has-route.js';

export default function transitionHasRoute(transition, route, key) {
  return routeInfoHasRoute(transition && transition[key || 'to'], route);
}
